<template>
  <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">REDES SOCIAIS</h2>

  <div v-for="(s, i) in value" :key="i" class="flex flex-wrap -mb-8 -mr-6 p-8">
    <select-input v-model="s.type" label="Tipo" class="mr-4">
      <option :value="null" />
      <option>facebook</option>
      <option>instagram</option>
      <option>whatsapp</option>
      <option>telegram</option>
      <option>pinterest</option>
      <option>youtube</option>
      <option>twitter</option>
    </select-input>
    <text-input v-model="s.value" label="Valor" />
    <div>
      <span @click="rm(i)"
        class="h-8 cursor-pointer w-8 flex justify-center items-center border border-gray-600 rounded-full "><i
          class="transition-all hover:text-lg text-red-600 hover:text-red-900"></i>X</span>

    </div>
  </div>

  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <button type="button" @click="add" class="btn-indigo ml-auto flex items-center">
      + Adicionar
    </button>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput
  },
  props: {
    value: Array,
  },
  data() {
    return {
    }
  },
  methods: {
    rm(i) {
      this.value.splice(i, 1);
    },
    add() {
      this.value.push({
        type: "",
        value: ""
      })
    }
  }
}
</script>
